import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography, Box, Icon, IconButton } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import Avatar from 'components/ui-component/extended/Avatar';

// ==============================|| SIDEBAR MENU Header ||============================== //

const NavHeader = ({ title, item, description, iconBefore }) => {
	const theme = useTheme();
	const navigate = useNavigate();

	// menu list collapse & items
	const items = item.children?.map(menu => {
		switch (menu.type) {
			case 'collapse':
				return <NavCollapse key={menu.id} menu={menu} level={1} />;
			case 'item':
				return <NavItem key={menu.id} item={menu} level={1} />;
			default:
				return (
					<Typography key={menu.id} variant="h6" color="error" align="center">
						Menu Items Error
					</Typography>
				);
		}
	});

	return (
		<>
			<Box display={'flex'} sx={{ mb: 1 }}>
				<Avatar color="secondary" variant="square" size="xs" sx={{ mr: 1, borderRadius: '3px' }}>
					{iconBefore ? <Icon>{iconBefore}</Icon> : <Inventory2OutlinedIcon />}
				</Avatar>
				{title && (
					<Typography
						variant="h4"
						sx={{ ...theme.typography.h4, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'wrap' }}
						display="block"
						alignSelf="center"
						gutterBottom
					>
						{title}
						{description && (
							<Typography
								variant="caption"
								sx={{
									...theme.typography.subMenuCaption,
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
								}}
								display="block"
								gutterBottom
							>
								{description}
							</Typography>
						)}
					</Typography>
				)}
				<Box sx={{ flexGrow: 1 }} />
				<IconButton
					color="secondary"
					onClick={() => {
						navigate(-1);
					}}
					sx={{ backgroundColor: `${theme.palette.grey[50]}` }}
				>
					<ArrowBackIcon />
				</IconButton>
			</Box>
			{/* divider */}
			<Divider sx={{ mt: 0.25, mb: 1.25 }} />
			<List>{items}</List>
		</>
	);
};

NavHeader.propTypes = {
	item: PropTypes.object,
	url: PropTypes.string,
};

export default NavHeader;
